import { render, staticRenderFns } from "./LessPay.vue?vue&type=template&id=5f9a6373&"
import script from "./LessPay.vue?vue&type=script&lang=js&"
export * from "./LessPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports